import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ApplicationConfigLog } from '@referrals/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigLogService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/applicationconfiglogs`;
  }

  public getById(id: number): Observable<ApplicationConfigLog[]> {
    return this.http.get<ApplicationConfigLog[]>(
      this.accessPointUrl + '/' + id,
      {
        headers: this.headers,
      }
    );
  }
}
